export const CATEGORIES_LOADING_ERROR =
  "Failed to load the list of space categories.";
